const INVALID_FIELD_SELECTOR = '[aria-invalid="true"], [data-field-error]';

const isHidden = (element) => !!element.closest('[hidden], .hidden');

/**
 * Scrolls the first field showing a validation error inside `container` into view.
 *
 * Text controls (Input, Select, Textarea, CurrencyInput) carry `aria-invalid` and are also
 * focused. Picker widgets (DatePicker, TimePicker, DateInputPicker, TextEditor) only mark their
 * wrapper with `data-field-error` — focusing them would pop their calendar or menu open, so
 * they are scrolled to but not focused.
 *
 * @param {HTMLElement} container
 * @returns {boolean} whether an invalid field was found
 */
export const revealFirstInvalidField = (container) => {
  if (!container) return false;

  const field = [...container.querySelectorAll(INVALID_FIELD_SELECTOR)].find(
    (element) => !isHidden(element)
  );
  if (!field) return false;

  field.scrollIntoView({ behavior: 'smooth', block: 'center' });
  if (field.matches('[aria-invalid="true"]')) field.focus({ preventScroll: true });
  return true;
};
